"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
exports.localStore = function () {
    var get = function (flagName) {
        return utils_1.safeParseJSON(window.localStorage.getItem(utils_1.getKey(flagName)));
    };
    return {
        name: 'localStore',
        get: get,
        set: function (flagName, value) {
            return window.localStorage.setItem(utils_1.getKey(flagName), JSON.stringify(value));
        },
        remove: function (flagName) { return window.localStorage.removeItem(utils_1.getKey(flagName)); },
        all: function () { return utils_1.mapFromStoredValuesWithPrefix(window.localStorage, get); }
    };
};
//# sourceMappingURL=local-store.js.map